import {useNavigate} from 'react-router-dom'
import {useServices} from '@/services/context'
import {usePageTitle} from '@/hooks/use-page-title'
import {ApprovalPolicyForm} from '@/components/ApprovalPolicyForm'
import {useI18n} from '@/i18n'
import {routes} from '@/lib/routes'
import type {CreateApprovalPolicyRequest, UpdateApprovalPolicyRequest} from '@/types/approval-policy'
import {useEntityMutation} from '@/hooks/useEntityMutation'
import {PageLayout} from '@/components/shared/PageLayout'
import {CONCEPT_ICON} from '@/lib/concepts'

export function ApprovalPolicyCreate() {
    const i18n = useI18n()
    const services = useServices()
    usePageTitle(i18n.approvalPolicies.createPageTitle)
    const navigate = useNavigate()

    const createMutation = useEntityMutation({
        mutationFn: (data: CreateApprovalPolicyRequest) =>
            services.approvalPolicies.create(data),
        invalidate: ['approval-policies'],
        successMessage: i18n.approvalPolicies.policyCreated,
        onSuccess: (policy) => {
            navigate(routes.accessGovernance.approvalPolicies.detail(policy.id))
        },
    })

    const handleSubmit = async (data: CreateApprovalPolicyRequest | UpdateApprovalPolicyRequest) => {
        await createMutation.mutateAsync(data as CreateApprovalPolicyRequest)
    }

    return (
        <PageLayout
            variant="detail"
            title={i18n.approvalPolicies.createPolicy}
            description={i18n.approvalPolicies.createCardDesc}
            icon={CONCEPT_ICON.approvalPolicy}
            backTo={true}
            data-testid="approval-policy-create-page"
        >
            <ApprovalPolicyForm
                onSubmit={handleSubmit}
                onCancel={() => navigate(-1)}
                isLoading={createMutation.isPending}
            />
        </PageLayout>
    )
}
